const $links = $('.header__link, .nav-drawer__link');
const $accountLink = $('#account-link');
const $dropdownLinks = $('.dropdown__link, .nav-drawer__dropdown-link');
const $metaDescriptions = $('meta[name="description"], meta[property="og:description"]');

// Init Functions
// --------------------------------------------------

function initPageLinks() {
	document.querySelectorAll('a').forEach((link) => {
		let href = link.getAttribute('href');
		let host = link.host;

		if (link.dataset.ignore || window.location.host !== host || href === '#') {
			return false;
		}

		// Check for files linked in workspace
		if (href.indexOf('/workspace/') !== -1) {
			link.dataset.ignore = true;
			link.target = '_blank';
			link.rel = 'noopener noreferrer';

			return false;
		}

		link.dataset.internal = true;

		link.addEventListener('click', (e) => {
			e.preventDefault();

			if (href !== link.getAttribute('href')) {
				// console.log('Update link href.');
				href = link.getAttribute('href');
			}

			// Return if the page is already loading
			if (PAGE.isLoading) return false;

			// Return if the link href matches the current page
			if (href === `//${window.location.host}${window.location.pathname}`) return false;
			if (href === window.location.href) return false;

			navigateTo(href);
		});
	});
}

function navigateTo(href) {
	console.log('load: ' + href);

	// Update the page loading state
	PAGE.isLoading = true;

	// Dispatch start event
	window.dispatchEvent(PAGE.events.loadStart);

	// Update nav link classes
	updateActiveState(href);

	// Load the page
	pageLoadStart(href)
		.then((data) => {
			return pageLoadUpdate(href, data);
		})
		.then(() => {
			return pageLoadComplete();
		})
		.then(() => {
			PAGE.isLoading = false;
		});
}

// Page States
// --------------------------------------------------

function pageLoadStart(href) {
	return new Promise(async (resolve) => {
		let data;
		let timeElapsed = 0;

		// Get new content
		ajax('GET', href).then((res) => (data = res));

		// Hide content
		await gsap.to($PAGE_CONTENT, {
			duration: 0.25,
			opacity: 0
		});

		// Dispatch hidden event
		window.dispatchEvent(PAGE.events.contentHidden);

		// Scroll to top
		await gsap.to(window, {
			duration: 0.25,
			scrollTo: 0
		});

		// Check if the data has loaded, then resolve the promise
		let interval = setInterval(() => {
			if (!data) {
				if (timeElapsed >= 500) {
					console.log("it's taking ages. :(");
					$BODY.addClass('loading');
				}
				timeElapsed += 250;
				return;
			}

			clearInterval(interval);
			resolve(data);
		}, 250);
	});
}

function pageLoadUpdate(href, data) {
	return new Promise((resolve) => {
		// Parse the new document
		const parser = new DOMParser();
		const $newDoc = $(parser.parseFromString(data, 'text/html'));

		// Get the new content/attributes
		const $newBody = $newDoc.find('body');
		const $newContent = $newDoc.find('#page-content');
		const $newAccountLink = $newDoc.find('#account-link');
		const title = $newDoc.find('title').text();
		const desc = $newDoc.find('meta[name="description"]').attr('content');

		// let height = $PAGE_CONTENT.outerHeight();

		$newDoc.imagesLoaded(async () => {
			// Replace the old content with the new content
			$PAGE_CONTENT.html($newContent.html());
			$PAGE_CONTENT.removeAttr('class').attr('class', $newContent.attr('class'));

			// Animate content height
			/*
			await gsap.from($PAGE_CONTENT, {
				duration: 0.25,
				clearProps: 'height',
				height: height
			});
			*/

			// Update the body classes
			$BODY.attr('class', $newBody.attr('class'));

			// Update the meta data
			document.title = title;
			$metaDescriptions.attr('content', desc);

			// Update account link (if user logs in/out)
			$accountLink.attr('href', $newAccountLink.attr('href'));

			// Change the page URL
			if (typeof window.history.pushState === 'function') {
				window.history.pushState('', '', href);
			}

			// Trigger gtag
			if (gtag && typeof gtag === 'function') {
				gtag('config', GTAG_ID, {
					page_title: title,
					page_path: href.split('.co.nz').pop()
				});
			}

			// Dispatch update event
			window.dispatchEvent(PAGE.events.contentUpdated);

			// Resolve the promise
			resolve(true);
		});
	});
}

function pageLoadComplete() {
	return new Promise(async (resolve) => {
		$BODY.removeClass('loading');

		// Show content
		await gsap.to($PAGE_CONTENT, {
			duration: 0.25,
			opacity: 1
		});

		// Dispatch load complete event
		window.dispatchEvent(PAGE.events.loadCompleted);

		// Resolve the promise
		resolve(true);
	});
}

// Misc Functions
// --------------------------------------------------

function updateActiveState(url) {
	$links.each(function () {
		const $link = $(this);
		const href = $link.attr('data-href') || $link.attr('href') || '';

		if (url == $link.attr('href') || url.indexOf(href) != -1) {
			$link.addClass('-active');
		} else {
			$link.removeClass('-active');
		}
	});

	$dropdownLinks.each(function () {
		const $link = $(this);

		if (url == $link.attr('href')) {
			$link.addClass('-active');
		} else {
			$link.removeClass('-active');
		}
	});
}

// Page events
// --------------------------------------------------

if (PAGE.supports.ajaxPageLoad) {
	$DOC.ready(() => {
		initPageLinks();
	});

	$WINDOW.on('page:load-completed', () => {
		initPageLinks();
	});

	$WINDOW.on('page:init-links', () => {
		initPageLinks();
	});

	$WINDOW.on('popstate', () => {
		window.location = document.location.href;
	});
}
